import { ArrowLeftRight, AlertCircle } from "lucide-react";

interface DashboardHeroProps {
  userName?: string;
  newOrders?: number;
  pendingItems?: number;
}

export default function DashboardHero({
  userName = "Ricardo",
  newOrders = 15,
  pendingItems = 9
}: DashboardHeroProps) {
  return (
    <div className="bg-[#09B068] rounded-[20px] p-6 md:p-[30px] h-auto md:h-[227px] flex flex-col md:flex-row justify-between gap-6 relative overflow-hidden">
      {/* Left Content */}
      <div className="flex flex-col justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-white mb-2">
            Bem vindo de volta, <span className="text-[#F5F2FF]">{userName}!</span>
          </h1>
          <p className="text-base text-[#E7E7E7]">
            Veja o que está acontecendo no sistema hoje.
          </p>
        </div>

        {/* Info Boxes */}
        <div className="flex flex-wrap gap-4">
          {/* New Orders */}
          <div className="flex items-center gap-3">
            <div className="bg-darkblue rounded-lg size-10 flex items-center justify-center">
              <ArrowLeftRight className="size-6 text-white" />
            </div>
            <div>
              <p className="text-base font-bold text-white">{newOrders} Novos Pedidos</p>
              <p className="text-sm text-[#262626]">Aguardando processamento</p>
            </div>
          </div>

          {/* Pending Items */}
          <div className="flex items-center gap-3">
            <div className="bg-darkblue rounded-lg size-10 flex items-center justify-center">
              <AlertCircle className="size-6 text-white" />
            </div>
            <div>
              <p className="text-base font-bold text-white">{pendingItems} Pendências</p>
              <p className="text-sm text-[#262626]">Aguardando aprovação</p>
            </div>
          </div>
        </div>
      </div>

      {/* Logo Area - Hidden on mobile */}
      <div className="hidden md:block bg-[#0B8A53] rounded-[20px] w-[188px] h-[165px] flex-shrink-0" />
    </div>
  );
}
